import {
  ADD_NOTIFICATIONS_SINGLE,
  ADD_NOTIFICATIONS_SINGLE_SUCCESS,
  ADD_NOTIFICATIONS_SINGLE_FAILURE,
  ADD_NOTIFICATIONS_MULTIPLE,
  ADD_NOTIFICATIONS_MULTIPLE_SUCCESS,
  ADD_NOTIFICATIONS_MULTIPLE_FAILURE,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_SUCCESS,
  CHANGE_NOTIFICATIONS_STATUS,
  CHANGE_NOTIFICATIONS_STATUS_FAILURE,
  CHANGE_NOTIFICATIONS_STATUS_SUCCESS,
} from "../constants";

const initialState = {
  unreadCount: 0,
  notifications: [],
  isLoading: false,
  isAddLoading: false,
  error: null,
};

export default function NotificationsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_NOTIFICATIONS:
    case CHANGE_NOTIFICATIONS_STATUS:
      state = {
        ...state,
        isLoading: true,
        error: null,
      };
      break;
    case ADD_NOTIFICATIONS_SINGLE:
    case ADD_NOTIFICATIONS_MULTIPLE:
      state = {
        ...state,
        isAddLoading: true,
        error: null,
      };
      break;
    case CHANGE_NOTIFICATIONS_STATUS_SUCCESS:
      state = {
        ...state,
        isLoading: false,
      };
      break;
    case ADD_NOTIFICATIONS_SINGLE_SUCCESS:
    case ADD_NOTIFICATIONS_MULTIPLE_SUCCESS:
      state = {
        ...state,
        isAddLoading: false,
        error: null,
      };
      break;
    case GET_NOTIFICATIONS_SUCCESS:
      state = {
        ...state,
        count: action.payload.count,
        unreadCount: action.payload.unreadCount,
        notifications: action.payload.notifications,
        isLoading: false,
      };
      break;
    case ADD_NOTIFICATIONS_SINGLE_FAILURE:
    case ADD_NOTIFICATIONS_MULTIPLE_FAILURE:
      state = {
        ...state,
        isAddLoading: false,
        error: null,
      };
      break;
    case GET_NOTIFICATIONS_FAILURE:
    case CHANGE_NOTIFICATIONS_STATUS_FAILURE:
      state = {
        ...state,
        isLoading: false,
        error: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
}
